import React, { useState, useEffect } from "react";
import { set, useForm, useFormState } from "react-hook-form";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Overlay from "../../Components/Overlay/Overlay";
import { uploadAsset, getAssetById, updateAsset } from "../../Services/AssetService";
import { getMetas } from "../../Services/MetaService";
import { getLimitById } from "../../Services/LimitService";
import { getMenus } from "../../Services/MenuService";
import { getTypes, getExtension } from "../../Services/TypeService";
import { getFilters } from "../../Services/FilterService";
import { handlerFormError } from "../../Utils/Utils";
import { Uploader } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { useSelector } from "react-redux";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useUploadForm } from "../../Services/AssetUploadService";
import { FileUploader } from "react-drag-drop-files";
import { readAndCompressImage } from "browser-image-resizer";
import AssetImageViewerUpload from "./AssetImageViewerUpload";

const { $ } = window;
let procesingId = -1;

const AssetBacthUpload = () => {
    const { pageState, id } = useParams();
    const { userInfo } = useSelector((state) => state.auth);
    //* new config for batch upload *//
    const [fileTypes, setFileTypes] = useState([]);
    const resizeConfig = {
        quality: 0.7,
        maxWidth: 128,
        maxHeight: 128,
        autoRotate: true,
        debug: true,
    };
    //* new config for batch upload *//
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
    } = useForm({
        defaultValues: {
            title: "Batch Upload",
            description: "Batch Upload",
            hastag: "#batch_upload",
            asset_month: new Date().toLocaleString("en-US", { month: "long" }),
            asset_year: new Date().getFullYear(),
            type_id: "",
            function_id: "",
            category_id: "",
            brand: "",
            filter_id: "2",
        },
    });

    const [checked, setChecked] = useState(false);
    const [checkedFile, setCheckedFile] = useState(true);
    const [checkedTrash, setCheckedTrash] = useState(true);
    const [isnotvalid, setIsNotValid] = useState(false);

    const [state, setState] = useState({
        asset: { type: { _id: -1 }, category: { _id: -1 }, filter: { _id: -1 }, function: { _id: -1 } },
        types: [],
        extensions: [],
        filters: [],
        main_menus: [],
        sub_menus: [],
        brands: [],
        thumbnail: "",
        preview_url: "",
        menu_num: 0,
        std_file_size: 0,
        high_file_size: 0,
        low_file_size: 0,
        raw_file_size: 0,
        highMaxUpload: 5,
        lowMaxUpload: 5,
        rawMaxUpload: 2,
        stdMaxUpload: 5,
        limit: {},
        meta: {},
        years: [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028],
        months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        processing: false,
        formats: ["header", "bold", "italic", "underline", "strike", "blockquote", "list", "bullet", "indent", "link", "image"],
        modules: {
            toolbar: [
                [{ header: [1, 2, false] }],
                ["bold", "italic", "underline", "strike", "blockquote"],
                [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
                ["link", "image"],
                ["clean"],
            ],
        },
        singleFileList: [],
        singleFileObj: [],
        highFileList: [],
        highFileObj: [],
        lowFileList: [],
        lowFileObj: [],
        rawFileList: [],
        rawFileObj: [],
        delStdFileList: [],
        delHigFileList: [],
        delLowFileList: [],
        delRawFileList: [],
    });

    const { isSuccess, uploadForm, progress } = useUploadForm();
    const [editorHtmlValue, setEditorHtmlValue] = useState("");
    const handleContentChange = (content, delta, source, editor) => {
        setEditorHtmlValue(content);
        setValue("description", content);
        // let has_attribues = delta.ops[1].attributes || "";
        //const cursorPosition = e.quill.getSelection().index;
        //this.quill.insertText(cursorPosition, "★");
        //this.quill.setSelection(cursorPosition + 1);
    };
    const setChange = (e) => {
        if (e.target.name === "function_id") {
            getMenus({ perpage: 100, filter: `parent._id:${e.target.value}`, order: `sort`, direction: `asc` }).then((res) => {
                setState({ ...state, menu_num: e.target.value, sub_menus: res.data.data, brands: [] });
            });
        } else if (e.target.name === "category_id") {
            getMenus({ perpage: 100, filter: `parent._id:${e.target.value}`, order: `sort`, direction: `asc` }).then((res) => {
                setState({ ...state, brands: ["Modena", "Mologiz", "Prive", "Ambiente", "MKS", "Culinaria"] });
            });
        } else if (e.target.name === "type_id") {
            //tambahan function untuk set file typenya
            let item = state.types.find((item) => item._id == e.target.value);
            setFileTypes(item.type_extension.split(", "));

            const { singleFileList, highFileList, lowFileList, rawFileList } = state;
            let sUpload = 5;
            let hUpload = 5;
            let lUpload = 5;
            let rUpload = 2;
            let delStd = [];
            let delHigh = [];
            let delLow = [];
            let delRow = [];

            if (e.target.value == 3) {
                sUpload = 1;
                hUpload = 1;
                lUpload = 1;
                rUpload = 1;
            }

            singleFileList.map((item) => {
                if (item.url !== "") delStd.push(item);
            });

            highFileList.map((item) => {
                if (item.url !== "") delHigh.push(item);
            });

            lowFileList.map((item) => {
                if (item.url !== "") delLow.push(item);
            });

            rawFileList.map((item) => {
                if (item.url !== "") delRow.pop(item);
            });

            getExtension({ id: "dot", code: e.target.value }).then((res) => {
                setState({
                    ...state,
                    extensions: res.data.data,
                    highMaxUpload: hUpload,
                    lowMaxUpload: lUpload,
                    rawMaxUpload: rUpload,
                    stdMaxUpload: sUpload,
                    singleFileObj: [],
                    highFileObj: [],
                    lowFileObj: [],
                    rawFileObj: [],
                    singleFileList: delStd,
                    highFileList: delHigh,
                    lowFileList: delLow,
                    rawFileList: delRow,
                });
            });
        }
    };

    const thumbnailUpload = (e) => {
        if (e.length > 0) {
            if (e[0].blobFile.size >= 750000) {
                //size in Byte = 750kb
                Swal.fire({
                    icon: "error",
                    title: "Save data failed!",
                    text: "Thumbnail size exceed limit max 750Kb, [uploaded size is : " + parseFloat(e[0].blobFile.size / 1000).toFixed(0) + "Kb] Pls remove manually",
                }).then((r) => {
                    setState({ ...state, thumbnail: "" });
                    setIsNotValid(true);
                });
            } else if (
                e[0].blobFile.type.toString() != "image/png" &&
                e[0].blobFile.type.toString() != "image/gif" &&
                e[0].blobFile.type.toString() != "image/jpg" &&
                e[0].blobFile.type.toString() != "image/jpeg"
            ) {
                Swal.fire({
                    icon: "error",
                    title: "Save data failed!",
                    text: "Thumbnail file type must png/gif/jpg/jpeg, Pls remove manually",
                }).then((r) => {
                    setState({ ...state, thumbnail: "" });
                    setIsNotValid(true);
                });
            } else {
                setState({ ...state, thumbnail: e[0].blobFile });
                setIsNotValid(false);
            }
        }
    };

    const thumbnailRemove = (e) => {
        setState({ ...state, thumbnail: "" });
        setIsNotValid(false);
    };

    const fileUpload = (e) => {
        if (e.length > 0) {
            let fSingle = [];
            let sObj = [];
            let size = 0;
            let ext = true;
            e.map((item) => {
                if (item.hasOwnProperty("blobFile")) {
                    ext = cekExtension(item.blobFile.name, item.blobFile.size, e.length, "std");
                    if (ext) {
                        sObj.push(item.blobFile);
                        size = size + item.blobFile.size;
                        fSingle.push({ name: item.name, fileKey: item.fileKey, url: item?.url || "" });
                    } else {
                        e.pop(item);
                    }
                } else {
                    fSingle.push({ name: item.name, fileKey: item.fileKey, url: item?.url || "" });
                }
            });

            setState({ ...state, singleFileList: fSingle, singleFileObj: sObj, std_file_size: size });
            setTimeout(() => {
                chechStorage("standard", size);
            }, 150);
        }
    };

    const fileRemove = (e) => {
        let size = 0;
        const { singleFileObj, singleFileList, delStdFileList } = state;
        let objList = singleFileObj;
        let stdFlist = singleFileList;
        let delList = delStdFileList;
        stdFlist.splice(
            stdFlist.findIndex((item) => item.fileKey === e.fileKey),
            1
        );
        objList.splice(
            objList.findIndex((item) => item.fileKey === e.fileKey),
            1
        );
        objList.map((item) => {
            size = size + item?.blobFile?.size || 0;
        });

        if (e.url !== undefined) {
            delList.push({ name: e.url });
        }

        setState({ ...state, std_file_size: size, singleFileObj: objList, singleFileList: stdFlist, delStdFileList: delList });
        setIsNotValid(false);
    };

    // const highUpload = e => {
    //     if (e.length > 0) {
    //         let fHigh = [];
    //         let sObj = [];
    //         let size = 0;
    //         let ext = true;
    //         e.map(item => {
    //             if (item.hasOwnProperty('blobFile')) {
    //                 ext = cekExtension(item.blobFile.name, item.blobFile.size, e.length, 'high')
    //                 if (ext) {
    //                     sObj.push(item.blobFile);
    //                     size = size + item.blobFile.size;
    //                     fHigh.push({ name: item.name, fileKey: item.fileKey, url: item?.url || '' })
    //                 } else {
    //                     e.pop(item)
    //                 }
    //             } else {
    //                 fHigh.push({ name: item.name, fileKey: item.fileKey, url: item?.url || '' })
    //             }
    //         });

    //         setState({ ...state, highFileList: fHigh, highFileObj: sObj, high_file_size: size });

    //         setTimeout(() => {
    //             chechStorage('high', size);
    //         }, 150);
    //     }
    // }

    // const highRemove = e => {
    //     let size = 0;
    //     const { highFileObj, highFileList, delHigFileList } = state
    //     let objList = highFileObj; let highFlist = highFileList; let delList = delHigFileList;
    //     highFlist.splice(highFlist.findIndex(item => item.fileKey === e.fileKey), 1)
    //     objList.splice(objList.findIndex(item => item.fileKey === e.fileKey), 1)
    //     objList.map(item => {
    //         size = size + item?.blobFile?.size || 0;
    //     });

    //     if ((e.url !== undefined)) {
    //         delList.push({ name: e.url });
    //     }

    //     setState({ ...state, high_file_size: size, highFileObj: objList, highFileList: highFlist, delHigFileList: delList });
    //     setIsNotValid(false);
    // }

    // const lowUpload = e => {
    //     if (e.length > 0) {
    //         let fLow = [];
    //         let sObj = [];
    //         let size = 0;
    //         let ext = true;
    //         e.map((item, i) => {
    //             if (item.hasOwnProperty('blobFile')) {
    //                 ext = cekExtension(item.blobFile.name, item.blobFile.size, e.length, 'low')
    //                 if (ext) {
    //                     sObj.push(item.blobFile);
    //                     size = size + item.blobFile.size;
    //                     fLow.push({ name: item.name, fileKey: item.fileKey, url: item?.url || '' })
    //                 } else {
    //                     e.pop(item)
    //                 }
    //             } else {
    //                 fLow.push({ name: item.name, fileKey: item.fileKey, url: item?.url || '' })
    //             }

    //         });

    //         setState({ ...state, lowFileList: fLow, lowFileObj: sObj, low_file_size: size });
    //         setTimeout(() => {
    //             chechStorage('low', size);
    //         }, 150);
    //     }
    // }

    // const lowRemove = e => {
    //     let size = 0;
    //     const { lowFileObj, lowFileList, delLowFileList } = state
    //     let objList = lowFileObj; let lowFList = lowFileList; let delList = delLowFileList
    //     lowFList.splice(lowFList.findIndex(item => item.fileKey === e.fileKey), 1)
    //     objList.splice(objList.findIndex(item => item.fileKey === e.fileKey), 1)
    //     objList.map(item => {
    //         size = size + item?.blobFile?.size || 0;
    //     });

    //     if ((e.url !== undefined)) {
    //         delList.push({ name: e.url });
    //     }

    //     setState({ ...state, low_file_size: size, lowFileObj: objList, lowFileList: lowFList, delLowFileList: delList });
    //     setIsNotValid(false);
    // }

    // const rawUpload = e => {
    //     if (e.length > 0) {
    //         let fRaw = [];
    //         let sObj = [];
    //         let size = 0;
    //         let ext = true;
    //         e.map((item, i) => {
    //             if (item.hasOwnProperty('blobFile')) {
    //                 ext = cekExtension(item.blobFile.name, item.blobFile.size, e.length, 'raw');
    //                 if (ext) {
    //                     sObj.push(item.blobFile);
    //                     size = size + item.blobFile.size;
    //                     fRaw.push({ name: item.name, fileKey: item.fileKey, url: item?.url || '' })
    //                 } else {
    //                     e.pop(item)
    //                 }
    //             } else {
    //                 fRaw.push({ name: item.name, fileKey: item.fileKey, url: item?.url || '' })
    //             }
    //         });

    //         setState({ ...state, rawFileList: fRaw, rawFileObj: sObj, raw_file_size: size });
    //         setTimeout(() => {
    //             chechStorage('raw', size);
    //         }, 150);
    //     }
    // }

    // const rawRemove = e => {
    //     let size = 0;
    //     const { rawFileObj, rawFileList, delRawFileList } = state
    //     let objList = rawFileObj; let rawFList = rawFileList; let delList = delRawFileList
    //     rawFList.splice(rawFList.findIndex(item => item.fileKey === e.fileKey), 1)
    //     objList.splice(objList.findIndex(item => item.fileKey === e.fileKey), 1)
    //     objList.map(item => {
    //         size = size + item?.blobFile?.size || 0;
    //     });

    //     if ((e.url !== undefined)) {
    //         delList.push({ name: e.url });
    //     }

    //     setState({ ...state, raw_file_size: size, rawFileObj: objList, rawFileList: rawFList, delRawFileList: delList });
    //     setIsNotValid(false);
    // }

    const cekExtension = (param, size, length, type) => {
        const { extensions, stdMaxUpload, highMaxUpload, lowMaxUpload, rawMaxUpload } = state;
        var _validFileExtensions = extensions;
        var sFileName = param;
        if (sFileName.length > 0) {
            var blnValid = false;
            for (var j = 0; j < _validFileExtensions.length; j++) {
                var sCurExtension = extensions[j];
                if (sFileName.substr(sFileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
                    blnValid = true;
                    break;
                }
            }

            if (!blnValid) {
                Swal.fire({
                    icon: "error",
                    title: "Upload data failed!",
                    text: "Sorry, " + sFileName + " is invalid, allowed extensions are: " + _validFileExtensions.join(", "),
                }).then();
                return false;
            }

            switch (type) {
                case "high":
                    if (size >= 50000000) {
                        //size in Byte = 50MB
                        Swal.fire({
                            icon: "error",
                            title: "Save data failed!",
                            text: "Thumbnail size exceed limit max 50MB, [uploaded size is : " + parseFloat(size / 1000).toFixed(0) + "Kb] Pls remove manually",
                        }).then();
                        return false;
                    }

                    if (length > highMaxUpload) {
                        Swal.fire({
                            icon: "error",
                            title: "Upload data failed!",
                            text: `Sorry, The number of files that can be uploaded is only ${highMaxUpload} `,
                        }).then();
                        return false;
                    }
                    break;
                case "low":
                    if (length > lowMaxUpload) {
                        if (size >= 3000000) {
                            //size in Byte = 3MB
                            Swal.fire({
                                icon: "error",
                                title: "Save data failed!",
                                text: "Thumbnail size exceed limit max 3MB, [uploaded size is : " + parseFloat(size / 1000).toFixed(0) + "Kb] Pls remove manually",
                            }).then();
                            return false;
                        }

                        Swal.fire({
                            icon: "error",
                            title: "Upload data failed!",
                            text: `Sorry, The number of files that can be uploaded is only ${lowMaxUpload} `,
                        }).then();
                        return false;
                    }
                    break;
                case "raw":
                    if (length > rawMaxUpload) {
                        Swal.fire({
                            icon: "error",
                            title: "Upload data failed!",
                            text: `Sorry, The number of files that can be uploaded is only ${rawMaxUpload} `,
                        }).then();
                        return false;
                    }
                    break;
                default:
                    if (length > stdMaxUpload) {
                        Swal.fire({
                            icon: "error",
                            title: "Upload data failed!",
                            text: `Sorry, The number of files that can be uploaded is only ${rawMaxUpload} `,
                        }).then();
                        return false;
                    }
                    break;
            }
        }

        return true;
    };

    const chechStorage = (param, size) => {
        const { high_file_size, low_file_size, raw_file_size, menu_num, limit, singleFileList, highFileList, lowFileList, rawFileList } = state;
        let total_upload = 0;
        switch (param) {
            case "high":
                total_upload = ((size + low_file_size + raw_file_size) / 1000000000).toPrecision(3);
                break;
            case "low":
                total_upload = ((high_file_size + size + raw_file_size) / 1000000000).toPrecision(3);
                break;
            case "raw":
                total_upload = ((high_file_size + low_file_size + size) / 1000000000).toPrecision(3);
                break;
            case "standard":
                total_upload = (size / 1000000000).toPrecision(3);
                break;
            default:
                total_upload = ((high_file_size + low_file_size + raw_file_size) / 1000000000).toPrecision(3);
                break;
        }

        let storage_free = 0;
        limit.bucket_used?.map((item) => {
            if (menu_num == item.id) {
                storage_free = item.free;
            }
        });

        if (storage_free < total_upload) {
            Swal.fire({
                icon: "error",
                title: "Save data failed!",
                text: "Incufuent Storage limit Free space : " + storage_free + ", Upload size is : " + total_upload + " Pls resize file manually",
            }).then((r) => {
                setIsNotValid(true);
            });
        }
    };

    const handleChange = () => {
        setChecked(!checked);
    };

    const handleChangeFile = () => {
        setCheckedFile(!checkedFile);
    };

    const handleChangeTrash = () => {
        setCheckedTrash(!checkedTrash);
    };

    const navigate = useNavigate();

    const onBack = () => {
        navigate(-1);
    };

    const startProcessing = () => {
        procesingId = setTimeout(() => {
            setState({ ...state, processing: true });
        }, 150);
    };

    const stopProcessing = () => {
        clearInterval(procesingId);
        setState({ ...state, processing: false });
    };

    // const onSubmit = (data) => {
    //     // const { singleFileList, singleFileObj, highFileList, delStdFileList, delHigFileList, delLowFileList, delRawFileList, highFileObj, lowFileList, lowFileObj, rawFileList, rawFileObj } = state;
    //     const formData = new FormData();

    //     for (var key in data) {
    //         formData.append(key, data[key]);
    //     }

    //     listThumbnail["thumbnail"].map((item, i) => {
    //         formData.append(`file_thumbnail[${i}]`, item);
    //     })

    //     fileTypes.map((item, i) => {
    //         formData.append(`file_type[${i}]`, item);
    //     })

    //     formData.append("objectAccess", "AclPrivate");

    //     if (checkedFile) {
    //         formData.append("is_active_file", 1);
    //     } else {
    //         formData.append("is_active_file", 0);
    //     }
    //     if (checkedTrash) {
    //         formData.append("is_archive_trash", 1);
    //     } else {
    //         formData.append("is_archive_trash", 0);
    //     }

    //     if (!checked) {
    //         photoFiles["photoHigh"].map((item, i) => {
    //             formData.append(`file_high[${i}]`, item);
    //         })

    //         formData.append('is_single', 0);
    //         formData.append('file_high_list', JSON.stringify(listPhotoHigh));

    //     }
    //     // console.log(formData)
    //     startProcessing();
    //     //const response = pageState.toLowerCase() == 'add' ? uploadAsset(formData) : updateAsset(id, formData);
    //     const url = `api/v1/admin/asset/batch`;
    //     const response = uploadForm(url, formData);
    //     response.then(res => {
    //         if (res.status == 200 || res.status == 201) {
    //             Swal.fire({
    //                 icon: 'success',
    //                 title: 'Save data success',
    //                 text: 'Data has been saved!'
    //             }).then(r => {
    //                 navigate("/asset");
    //             })
    //         }
    //     }).catch(({ response: { data } }) => {
    //         handlerFormError(data);
    //     }).finally(_ => stopProcessing());
    // }

    //new on submit buat ngakalin masalah upload file cuma bisa 6 maks

    const onSubmit = async (data) => {
        //validasi
        //jika file arrray ksoong
        if (photoFiles["photoHigh"].length == 0) {
            Swal.fire({
                icon: "error",
                title: "Save data failed!",
                text: "Please upload at least one file!",
            });
            return;
        }
        //jika brand kosong
        if (data.brand == "-1" || !data.brand) {
            Swal.fire({
                icon: "error",
                title: "Save data failed!",
                text: "Please select brand!",
            });
            return;
        }

        if (data.category_id === "-1" || !data.category_id) {
            return Swal.fire({
                icon: "error",
                title: "Save data failed!",
                text: "Please select category!",
            });
        }

        if (data.function_id === "-1" || !data.function_id) {
            return Swal.fire({
                icon: "error",
                title: "Save data failed!",
                text: "Please select storage!",
            });
        }

        const batchSize = 6;
        startProcessing();

        try {
            for (let i = 0; i < photoFiles["photoHigh"].length; i += batchSize) {
                const formData = new FormData();

                for (var key in data) {
                    formData.append(key, data[key]);
                }
                listThumbnail["thumbnail"].slice(i, i + batchSize).forEach((item, index) => {
                    formData.append(`file_thumbnail[${index}]`, item);
                });

                fileTypes.forEach((item, index) => {
                    formData.append(`file_type[${index}]`, item);
                });
                formData.append("objectAccess", "AclPrivate");
                formData.append("is_active_file", checkedFile ? 1 : 0);
                formData.append("is_archive_trash", checkedTrash ? 1 : 0);
                formData.append("is_single", 0);

                photoFiles["photoHigh"].slice(i, i + batchSize).forEach((item, index) => {
                    formData.append(`file_high[${index}]`, item);
                });

                formData.append("file_high_list", JSON.stringify(listPhotoHigh.slice(i, i + batchSize)));

                const url = `api/v1/admin/asset/batch`;
                const response = await uploadForm(url, formData);

                if (response.status !== 200 && response.status !== 201) {
                    throw new Error("Failed to upload batch");
                }
            }

            Swal.fire({
                icon: "success",
                title: "Save data success",
                text: "All files have been successfully uploaded!",
            }).then(() => {
                navigate("/asset");
            });
        } catch (error) {
            handlerFormError(error.response.data);
        } finally {
            stopProcessing();
        }
    };

    const onReset = () => {
        setChecked(false);
        setCheckedFile(true);
        setCheckedTrash(true);
        setState({
            ...state,
            asset: { _id: -1 },
            thumbnail: "",
            menu_num: 0,
            years: [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027],
            months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            processing: false,
            singleFileList: [],
            singleFileObj: [],
            highFileList: [],
            highFileObj: [],
            lowFileList: [],
            lowFileObj: [],
            rawFileList: [],
            rawFileObj: [],
        });

        reset({
            title: "",
            description: "",
            hastag: "",
            asset_month: "",
            asset_year: "",
            type_id: "",
            function_id: "",
            category_id: "",
            brand: "",
            filter_id: "",
            std_file_size: 0,
            high_file_size: 0,
            low_file_size: 0,
            raw_file_size: 0,
            menu_num: 0,
        });
    };

    //* NEW STATE FOR BATCH UPLOAD *//
    const [isHover, setIsHover] = useState({
        photoHigh: false,
    });
    const [isLoading, setIsLoading] = useState(false);
    const handleHover = (type, state) => {
        setIsHover((prevData) => ({
            ...prevData,
            [type]: state,
        }));

        if (!state) {
            setIsHover((prevData) => ({
                ...prevData,
                [type]: false,
            }));
        }
    };

    const [photoFiles, setPhotoFiles] = useState({
        photoHigh: [],
    });

    const [listPhotoHigh, setListPhotoHigh] = useState([]);
    const [listPhotoThumb, setListPhotoThumb] = useState([]);

    const [listThumbnail, setListThumbnail] = useState({
        thumbnail: [],
    });

    const resizeAndUpload = async (file) => {
        const resizeConfig = {
            quality: 0.9,
            maxWidth: 1280,
            maxHeight: 1280,
            autoRotate: true,
            debug: true,
        };

        try {
            setIsLoading(true);

            // Handle image files
            if (file.type.startsWith("image")) {
                let resizedImage = await readAndCompressImage(file, resizeConfig);
                let resizedBlob = new Blob([resizedImage], { type: resizedImage.type });

                while (resizedBlob.size > 128 * 1024 && resizeConfig.quality > 0.1) {
                    resizeConfig.quality -= 0.1;
                    resizedImage = await readAndCompressImage(file, resizeConfig);
                    resizedBlob = new Blob([resizedImage], { type: resizedImage.type });
                }

                if (resizedBlob.size > 500 * 1024) {
                    console.log("Unable to reduce image size below 500KB");
                    throw new Error("Unable to reduce image size below 500KB");
                }

                return resizedBlob;
            } else if (file.type.startsWith("video")) {
                return await extractVideoThumbnail(file);
            } else if (file.type.endsWith("pdf")) {
                const response = await fetch(`/dist/img/document.png`);
                const imageBlob = await response.blob();
                return imageBlob;
                // return "/dist/img/document.png";
            } else if (file.type.startsWith("audio")) {
                const response = await fetch(`/dist/img/waveform.png`);
                const imageBlob = await response.blob();
                return imageBlob;

            }
            const response = await fetch(`/dist/img/no-image.png`);
            const imageBlob = await response.blob();
            return imageBlob;

        } catch (error) {
            console.error("Failed to process file", error);
            Swal.fire({
                icon: "error",
                title: "File processing failed",
                text: "There was a problem processing the file.",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const extractVideoThumbnail = (file) => {
        return new Promise((resolve, reject) => {
            const video = document.createElement("video");
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");

            video.preload = "metadata"; // Preloads the metadata to ensure duration is available
            video.src = URL.createObjectURL(file);

            video.onloadedmetadata = () => {
                // Seek to a moment of the video where we hope to not get a black frame.
                video.currentTime = Math.min(Math.max(0, video.duration / 4), 1); // Captures frame at 1/4th of the duration or at 1 second.
            };

            video.onseeked = () => {
                try {
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    context.drawImage(video, 0, 0, canvas.width, canvas.height);
                    canvas.toBlob(
                        (blob) => {
                            resolve(blob); // Returns the blob directly
                        },
                        "image/jpeg",
                        0.7
                    );
                } catch (error) {
                    reject(error);
                } finally {
                    URL.revokeObjectURL(video.src); // Clean up to avoid memory leaks
                }
            };

            video.onerror = () => {
                reject("Error when loading video file");
            };
        });
    };

    const generateFileKey = (file) => `${file.name}-${file.lastModified}`;

    const handleChangeFileUpload = async (newFiles, photoType) => {
        let arrDuplicate = [];
        let arrNewFiles = [];
        let arrNewThumbnails = [];

        for (let key in newFiles) {
            let elem = newFiles[key];
            if (elem.size && elem.name) {
                let sanitizedFileName = elem.name.replace(/-/g, "_");
                let isExist = photoFiles[photoType].some((item) => item.name === sanitizedFileName);
                if (isExist) {
                    arrDuplicate.push(elem);
                } else {
                    try {
                        const resizedImage = await resizeAndUpload(elem);

                        const resizedImageFile = new File([resizedImage], sanitizedFileName, {
                            type: resizedImage.type,
                            lastModified: elem.lastModified,
                        });

                        const fileWithSanitizedName = new File([elem], sanitizedFileName, {
                            type: elem.type,
                            lastModified: elem.lastModified,
                        });

                        arrNewFiles.push(fileWithSanitizedName);
                        arrNewThumbnails.push(resizedImageFile);

                        setListPhotoHigh((prevData) => [...prevData, { name: sanitizedFileName, fileKey: generateFileKey(elem), url: "" }]);
                        setListPhotoThumb((prevData) => [...prevData, { name: `thumb-${sanitizedFileName}`, fileKey: `thumb-${generateFileKey(elem)}`, url: "" }]);
                    } catch (error) {
                        console.error("Failed to resize image", error);
                        Swal.fire({
                            icon: "error",
                            title: "Image resizing failed",
                            text: "There was a problem resizing the image.",
                        });
                    }
                }
            }
        }

        if (arrDuplicate.length > 0) {
            Swal.fire({
                icon: "warning",
                title: "Duplicate file name",
                text: `Some of these files are not uploaded because they already exist in the list, 
                list of the files: ${arrDuplicate.map((item) => item.name).join(", ")}`,
            });
        }

        setPhotoFiles((prevFiles) => ({
            ...prevFiles,
            [photoType]: [...prevFiles[photoType], ...arrNewFiles],
        }));

        setListThumbnail((prevThumbnails) => ({
            ...prevThumbnails,
            thumbnail: [...prevThumbnails.thumbnail, ...arrNewThumbnails],
        }));

        console.log(arrNewFiles);
    };

    const updateFile = (newFiles, photoType, index) => {
        setPhotoFiles((prevFiles) => ({
            ...prevFiles,
            [photoType]: newFiles,
        }));

        setListThumbnail((prevThumbnails) => ({
            ...prevThumbnails,
            thumbnail: prevThumbnails.thumbnail.filter((_, idx) => idx !== index),
        }));

        setListPhotoHigh((prevData) => prevData.filter((_, idx) => idx !== index));
        setListPhotoThumb((prevData) => prevData.filter((_, idx) => idx !== index));
    };
    //* NEW STATE FOR BATCH UPLOAD *//

    useEffect(() => {
        const requests = [
            getTypes({ perpage: 50, filter: `is_active:true`, order: `type_code`, direction: `asc` }).then((res) => res.data.data),
            getFilters({ perpage: 50, filter: `is_active:true`, order: `filter_name`, direction: `asc` }).then((res) => res.data.data),
            getMenus({ perpage: 50, filter: `menu_level:1,is_active:true`, order: `sort`, direction: `asc` }).then((res) => res.data.data),
            getExtension({ id: "dot", code: "" }).then((res) => res.data.data),
            getLimitById(1).then((res) => res.data),
            getMetas({ perpage: 10, select: `meta_table`, filter: `meta:storage_period,is_active:true`, order: `sort`, direction: `asc` }).then((res) => res.data.data),
        ];

        Promise.all(requests).then((results) => {
            const [_types, _filters, _menus, _extensions, _limit, _meta] = results;
            setState({
                ...state,
                types: _types,
                filters: _filters,
                main_menus: _menus,
                extensions: _extensions,
                limit: _limit,
                meta: _meta[0],
            });
        });

    }, []);

    const {
        processing,
        types,
        filters,
        thumbnail,
        singleFileList,
        highFileList,
        lowFileList,
        rawFileList,
        years,
        months,
        main_menus,
        sub_menus,
        brands,
        preview_url,
        meta,
        highMaxUpload,
        lowMaxUpload,
        rawMaxUpload,
        stdMaxUpload,
    } = state;

    return (
        <div className="content-wrapper">
            {/* {JSON.stringify(types)} */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-left">
                                <li className="breadcrumb-item">
                                    <NavLink to="/home">Home</NavLink>
                                </li>
                                <li className="breadcrumb-item">
                                    <NavLink to="/asset">Asset</NavLink>
                                </li>
                                <li className="breadcrumb-item active">Batch Upload Asset</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            {/* <img src="/dist/img/document.png" alt="Description" /> */}
                            <div className="card">
                                <Overlay display={processing} progress={progress} />
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="card-header" style={{ height: 41 }}>
                                        <div className="card-title">
                                            <i className="fa fa-user-tag" /> Batch Upload Asset{" "}
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="row justify-content-md-center">
                                            {/* {JSON.stringify(isHover)} */}

                                            <div className="col-8">
                                                <div className="row mb-3">
                                                    <label htmlFor="type_id" className="col-sm-2 col-form-label mandatory">
                                                        Asset Type
                                                    </label>
                                                    <div className="col-sm-10">
                                                        <div>
                                                            <select
                                                                id="type_id"
                                                                className="form-control"
                                                                {...register("type_id", { required: "Asset type is required!" })}
                                                                onChange={setChange}
                                                                disabled={listThumbnail["thumbnail"].length > 0}
                                                            >
                                                                <option value="-1">-- Select Asset Type --</option>
                                                                {types.map((item, i) => (
                                                                    <option key={`asset-type-${i}`} value={item._id}>
                                                                        {item.type_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errors.type_id && <span className="text-danger">{errors.type_id.message}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label htmlFor="title" className="col-sm-2 col-form-label mandatory">
                                                        Storage
                                                    </label>
                                                    <div className="col-sm-10">
                                                        <div>
                                                            <select id="function_id" className="form-control" {...register("function_id", { required: "Asset function is required!" })} onChange={setChange}>
                                                                <option value="-1">-- Select Storage --</option>
                                                                {main_menus?.map((item, i) => (
                                                                    <option key={`folder-${i}`} value={item._id}>
                                                                        {item.menu_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errors.function_id && <span className="text-danger">{errors.function_id.message}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label htmlFor="title" className="col-sm-2 col-form-label mandatory">
                                                        Category
                                                    </label>
                                                    <div className="col-sm-10">
                                                        <div>
                                                            <select id="category_id" className="form-control" {...register("category_id", { required: "Asset category is required!" })} onChange={setChange}>
                                                                <option value="-1">-- Select Category --</option>
                                                                {sub_menus?.map((item, i) => (
                                                                    <option key={`category-${i}`} value={item._id}>
                                                                        {item.menu_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errors.category_id && <span className="text-danger">{errors.category_id.message}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label htmlFor="title" className="col-sm-2 col-form-label mandatory">
                                                        Brand
                                                    </label>
                                                    <div className="col-sm-10">
                                                        <div>
                                                            <select id="brand" defaultValue={"-1"} className="form-control" {...register("brand", { required: "Asset brand is required!" })}>
                                                                <option value="-1">-- Select Brand --</option>
                                                                {brands?.map((item, i) => (
                                                                    <option key={`brand-${i}`} value={item}>
                                                                        {item}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errors.brand && <span className="text-danger">{errors.brand.message}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label htmlFor="type" className="col-sm-2 col-form-label mandatory">
                                                        Asset Files
                                                    </label>
                                                    <div className="col-sm-10">
                                                        <div className="form-check" style={{ paddingBottom: "10px" }}>
                                                            <input className="form-check-input" type="checkbox" id="opt_active_file" checked={checkedFile} onChange={() => handleChangeFile()} />
                                                            <label className="form-check-label" htmlFor="opt_active_file">
                                                                Is Active Standard?
                                                            </label>{" "}
                                                            <h6>* {meta.meta_table?.active_file_message}</h6>
                                                        </div>
                                                        <div className="form-check" style={{ paddingBottom: "10px" }}>
                                                            <input className="form-check-input" type="checkbox" id="opt_archive_trash" checked={checkedTrash} onChange={() => handleChangeTrash()} />
                                                            <label className="form-check-label" htmlFor="opt_archive_trash">
                                                                Is Archive Trash Bin?
                                                            </label>{" "}
                                                            <h6>* {meta.meta_table?.archive_trash_message}</h6>
                                                        </div>

                                                        {fileTypes.length > 0 && (
                                                            <div>
                                                                {isLoading ? (
                                                                    <div className="d-flex mt-5" style={{ justifyContent: "center", alignItems: "center", height: 54, width: "100%" }}>
                                                                        <div className="spinner-border" role="status" />
                                                                    </div>
                                                                ) : (
                                                                    <div className="row mb-3">
                                                                        <p htmlFor="high" className="form-label">
                                                                            High Size
                                                                        </p>
                                                                        {photoFiles["photoHigh"].length === 0 && (
                                                                            <FileUploader
                                                                                handleChange={(files) => handleChangeFileUpload(files, "photoHigh")}
                                                                                name="supporting_file"
                                                                                types={fileTypes}
                                                                                multiple={true}
                                                                                onDraggingStateChange={(dragging) => handleHover("photoHigh", dragging)}
                                                                                hoverTitle=""
                                                                                onTypeError={(err) => Swal.fire({ icon: "error", title: "Save data failed!", text: err }).then()}
                                                                                maxSize={51}
                                                                                onSizeError={(err) => Swal.fire({ icon: "error", title: "Save data failed!", text: err }).then()}
                                                                                children={
                                                                                    <div className="d-flex justify-content-center rounded border border-2" style={{ cursor: "pointer", padding: "28px 0 28px 0" }}>
                                                                                        <div className="text-center">
                                                                                            <div className="d-flex align-items-center">
                                                                                                <div className="">
                                                                                                    {!isHover["photoHigh"] && (
                                                                                                        <>
                                                                                                            <label htmlFor="supporting_file" className="d-block text-center fw-semibold text-primary">
                                                                                                                <span>Upload media files</span>
                                                                                                            </label>
                                                                                                            <p className="text-muted text-center">or drag and drop</p>
                                                                                                            <p className="text-muted text-center small">{fileTypes.join(", ")} up to 50MB</p>
                                                                                                        </>
                                                                                                    )}
                                                                                                    {isHover["photoHigh"] && (
                                                                                                        <>
                                                                                                            <label htmlFor="supporting_file" className="d-block text-center fw-semibold text-primary">
                                                                                                                <span>Drop your files here...</span>
                                                                                                            </label>
                                                                                                            <p className="text-muted text-center">or drag and drop</p>
                                                                                                            <p className="text-muted text-center small">JPG, JPEG, PNG, MP4, MKV, AVI</p>
                                                                                                        </>
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                }
                                                                            />
                                                                        )}

                                                                        {/* jika sudah upload */}
                                                                        {photoFiles["photoHigh"].length > 0 && (
                                                                            <div className="row">
                                                                                <AssetImageViewerUpload photoFiles={listThumbnail["thumbnail"]} setPhotoFiles={updateFile} type={"photoHigh"} />
                                                                            </div>
                                                                        )}

                                                                        {/* <div className='form-control'>
                                                                    <Uploader
                                                                        name="file_high"
                                                                        multiple={true}
                                                                        autoUpload={false}
                                                                        listType="picture-text"
                                                                        defaultFileList={highFileList}
                                                                        fileList={highFileList}
                                                                        removable={true}
                                                                        onChange={e => highUpload(e)}
                                                                        disabled={highFileList.length >= highMaxUpload ? true : false}
                                                                        onRemove={e => highRemove(e)}
                                                                        action=''
                                                                        renderFileInfo={(file, fileElement) => {
                                                                            return (
                                                                                <><span>File Name : {file.name}</span></>
                                                                            );
                                                                        }}
                                                                        draggable>
                                                                        <div style={{ height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'darkgrey' }}>
                                                                            <span>Drop File Here..</span>
                                                                        </div>
                                                                    </Uploader>
                                                                </div> */}
                                                                        {/* {errors.file_high && <span className='text-danger'>{errors.file_high.message}</span>} */}
                                                                    </div>
                                                                )}

                                                                {photoFiles["photoHigh"].length > 0 && (
                                                                    <div className="d-flex align-items-center justify-content-center h-100 mt-5">
                                                                        <FileUploader
                                                                            handleChange={(files) => handleChangeFileUpload(files, "photoHigh")}
                                                                            name="supporting_file"
                                                                            types={fileTypes}
                                                                            multiple={true}
                                                                            onDraggingStateChange={(dragging) => handleHover("photoHigh", dragging)}
                                                                            hoverTitle="Drop your supporting files here..."
                                                                            onTypeError={(err) => Swal.fire({ icon: "error", title: "Save data failed!", text: err }).then()}
                                                                            maxSize={51}
                                                                            onSizeError={(err) => Swal.fire({ icon: "error", title: "Save data failed!", text: err }).then()}
                                                                            children={
                                                                                <div style={{ padding: "0.5rem" }}>
                                                                                    <button type="button" className="btn btn-sm btn-outline-warning p-1 shadow-sm">
                                                                                        + Add New Files
                                                                                    </button>
                                                                                </div>
                                                                            }
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card-footer">
                                        <div className="row">
                                            <div className="col-md-10">
                                                <div className="d-flex" style={{ justifyContent: "flex-end" }}>
                                                    <button type="button" className="btn btn-outline-dark mr-3" style={{ width: 100 }} onClick={onBack}>
                                                        <i className="fa fa-reply" /> Back
                                                    </button>

                                                    <button type="submit" className="btn btn-dark" style={{ width: 100 }} disabled={isnotvalid}>
                                                        <i className="fa fa-save" /> Save
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div style={{ height: 20 }} />
        </div>
    );
};

export default AssetBacthUpload;
